<template>
	<div class="ResendActivation">
		<el-dialog
			:visible.sync="dialogVisible"
			:close-on-click-modal="false"
			:before-close="handleClose"
		>
			<div class="ResendActivation_center_div">
				<p class="text-right m-0">
					<img
						src="../../assets/images/close-button.png"
						alt=""
						srcset=""
						width="15"
						class="cursor-pointer"
						@click="$router.push({ path: '/' }).catch(()=>{})"
					/>
				</p>
				<div class="messsage-section">
					<p>
						You must activate your account with the link sent to your email
						address.If you did not receive this email, please check your
						junk/spam folder or click here to resend the activation email.
					</p>
					<div class="link-section">
						<p v-if="show_disabled_link" class="disabled-link">
							Resend activation link
						</p>
						<p v-else class="enabled-link" @click="ClickForActivateResend">
							Resend activation link
						</p>
					</div>
				</div>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import { serverAddr } from "../../networkConfig";
import { ResendActivationNC } from "../../../mixins/ResendActivationNC";

export default {
	name: "ResendActivation",
	mixins: [ResendActivationNC],
	props: [],
	data() {
		return {
			dialogVisible: true,
			show_disabled_link: false
		};
	},
	computed: {
		getStoreEmail: function() {
			return this.$store.state.store_email;
		}
	},
	created() {},
	methods: {
		ClickForActivateResend: function() {
			serverAddr
				.post("/users/activate/resend/", {
					email: this.getStoreEmail
				})
				.then(this.postActivateResendtNC)
				.catch(error => {
					this.$notify.error({
						title: "Error",
						message: JSON.parse(error.response.data).email[0],
						type: "Error"
					});
				});
		}
	}
};
</script>

<style lang="scss" scoped>
@import "./ResendActivation.scss";
</style>
<style>
.ResendActivation .el-icon-close {
	display: none;
}
.ResendActivation .el-dialog {
	height: auto;
	max-height: 90%;
	max-width: 650px;
	width: 680px;
	margin-top: 0 !important;
}
@media screen and (max-width: 700px) {
	.ResendActivation .el-dialog {
		width: 90%;
	}
}

.ResendActivation .el-dialog__body {
	padding: 0 0 30px 0;
}
.ResendActivation .el-dialog__header {
	@apply p-0;
}
.ResendActivation .ResendActivation_button {
	text-align: right !important;
}
.ResendActivation .el-button--primary {
	background-color: #2c9bce;
	padding: 13px 12px 11px;
	border-radius: 2px;
	font-size: 15px;
	cursor: pointer;
	letter-spacing: 0.02em;
	transition: all 0.2s ease;
	color: #fff;
	border: none;
}
@media screen and (max-width: 576px) {
	.ResendActivation .ResendActivation_button {
		margin-top: 20px;
		text-align: center !important;
	}
}
</style>
